module.exports = __webpack_public_path__ + "static/media/LS.e15cc5ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LS.svg
// module id = 302
// module chunks = 0